"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@xstate/react");
const get_1 = __importDefault(require("lodash/get"));
const moment_1 = __importDefault(require("moment"));
const prop_types_1 = require("prop-types");
const react_2 = __importStar(require("react"));
const xstate_1 = require("xstate");
const useHeaderHeight_1 = __importDefault(require("../../hooks/useHeaderHeight"));
const configUtils_1 = require("../../lib/configUtils");
const Actions_1 = require("../../lib/constants/Actions");
const States_1 = require("../../lib/constants/States");
const Tracking_1 = require("../../lib/constants/Tracking");
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
const utils_1 = require("../../lib/utils");
const Banners_1 = require("../Banners");
const utils_directBook_1 = require("../DirectBook/utils.directBook");
const MobileAltProviders_1 = __importDefault(require("../MobileAltProviders"));
const ProviderLocations_1 = __importDefault(require("../ProviderLocations"));
const Recaptcha_1 = require("../Recaptcha");
const Sidebar_1 = require("../Sidebar");
const ApptList_1 = __importDefault(require("./ApptList"));
const CollapsibleFilters_1 = require("./CollapsibleFilters");
const Loading_1 = __importDefault(require("./Loading"));
const styles_1 = require("./styles");
const TimeFilter_1 = require("./TimeFilter");
const VisitTypeContent_1 = __importDefault(require("./VisitTypeContent"));
// if we ask for 8:30 we may get a result that's
// between 8:00-8:30 and end up in an infinite loop.
// Asking for 8:31 will return 8:30-9:00
const nextPeriodStart = (appointments) => (0, moment_1.default)(appointments[appointments.length - 1].end_datetime).add(1, 'minute');
const propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    config: (0, prop_types_1.shape)({
        recaptchaSiteKey: prop_types_1.string
    }).isRequired,
    darkshipFeatureFlags: prop_types_1.object,
    track: prop_types_1.func.isRequired,
    mapApiKey: prop_types_1.string,
    apptDensity: (0, prop_types_1.oneOf)(['default', 'dense']),
    onScroll: prop_types_1.func,
    offsetTop: prop_types_1.number,
    awsMapConfig: prop_types_1.object,
    showAltProvidersOnStep2: prop_types_1.bool
};
const defaultProps = {
    mapApiKey: null
};
function ApptTime({ service, config, track, mapApiKey, apptDensity, onScroll, offsetTop, awsMapConfig, showAltProvidersOnStep2 }) {
    const [state, send] = (0, react_1.useService)(service);
    const [highlightedLocId, setHighLightedLocId] = (0, react_2.useState)(null);
    const { appointments, query, provider, locsByAvailability, locationId, // deep-linked location id if it exists
    filterBy, jumpedToDate, filterCount, featureFlags, darkshipFeatureFlags, customerCode, productName, apiBaseURL, services, careTeamsProviders, shouldShowCareTeamsInSidebar } = state.context;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const showAltProvidersForMobile = !aboveMd && showAltProvidersOnStep2;
    // Use computed property from state machine to reduce component logic
    const showCareTeamsOnStep2 = shouldShowCareTeamsInSidebar;
    const useNewFilters = (0, get_1.default)(darkshipFeatureFlags, 'use_new_filters', false);
    const [headerHeight] = (0, useHeaderHeight_1.default)();
    (0, react_2.useEffect)(() => {
        if (state.matches(`${States_1.jumpToDate}.${States_1.noResults}`)) {
            track(Tracking_1.userEvents.APPT_JUMP_TO_DATE_NO_RESULTS);
        }
        if (state.matches(`${States_1.newSearch}.${States_1.noResults}`) ||
            state.matches(`${States_1.loadingAvailableLocs}.${States_1.loadingAvailableLocsError}`)) {
            track(Tracking_1.userEvents.APPT_NO_RESULTS);
        }
        if (state.matches(`${States_1.newSearch}.${States_1.deepLinkingTimeSlotUnavailableError}`)) {
            track(Tracking_1.deepLinkingEvents.TIME_SLOT_UNAVAILABLE_ERR);
        }
    }, [state, track]);
    const isFetchingAltProviders = state.matches(States_1.fetchingAltProviders);
    const isLoadingAvailableLocsPending = state.matches(`${States_1.loadingAvailableLocs}.${States_1.pending}`);
    const isNewSearchPending = [
        `${States_1.newSearch}.${States_1.pending}`,
        `${States_1.jumpToDate}.${States_1.pending}`
    ].some(state.matches);
    const isPendingEhrPatientDemographics = state.matches(`${States_1.pendingEhrPatientDemographics}`);
    const isNewSearchRouting = state.matches(`${States_1.newSearch}.${States_1.routing}`);
    const isCheckingCaptchaSession = state.matches(`${States_1.newSearch}.${States_1.checkingCaptchaSession}`);
    const getMapZoomRefOnLoad = (0, react_2.useRef)(null);
    (0, react_2.useEffect)(() => {
        // reset scroll position on new searches
        if (onScroll)
            onScroll();
    }, [isNewSearchPending, isPendingEhrPatientDemographics, onScroll]);
    const handleCaptchaVerified = (isCaptchaVerified) => {
        send({
            type: Actions_1.CAPTCHA_VERIFIED,
            data: isCaptchaVerified
        });
    };
    const handleCaptchaCancelled = () => {
        send(Actions_1.CAPTCHA_CANCELLED);
    };
    const handleCaptchaError = () => {
        send(Actions_1.CAPTCHA_ERROR);
    };
    const handleCaptchaReset = () => {
        send(Actions_1.CAPTCHA_RESET);
    };
    if (isFetchingAltProviders ||
        isLoadingAvailableLocsPending ||
        isNewSearchPending ||
        isNewSearchRouting ||
        isPendingEhrPatientDemographics ||
        isCheckingCaptchaSession) {
        return (react_2.default.createElement(styles_1.Container, { "data-testid": "ApptTime" },
            react_2.default.createElement(Loading_1.default, null)));
    }
    const phone = (0, configUtils_1.shouldHideSchedulingHelpMessages)(config)
        ? ''
        : (0, utils_1.getMainContactNumber)(provider);
    if (state.matches(`${States_1.newSearch}.${States_1.noResults}`) ||
        state.matches(`${States_1.loadingAvailableLocs}.${States_1.loadingAvailableLocsError}`)) {
        return (react_2.default.createElement(styles_1.Container, { "data-testid": "ApptTime" },
            react_2.default.createElement(Banners_1.ErrorBookingBanner, { phone: phone })));
    }
    if (state.matches(`${States_1.newSearch}.${States_1.verifyingCaptcha}`)) {
        return (react_2.default.createElement(styles_1.Container, { "data-testid": "ApptTime" },
            react_2.default.createElement(Recaptcha_1.RecaptchaModal, { onCancel: handleCaptchaCancelled, onVerified: handleCaptchaVerified, onError: handleCaptchaError, siteKey: config.recaptchaSiteKey, customerCode: customerCode, productName: productName, apiBaseURL: apiBaseURL })));
    }
    if (state.matches(`${States_1.newSearch}.${States_1.verifyingCaptchaError}`)) {
        return (react_2.default.createElement(Recaptcha_1.RecaptchaErrorModal, { onClose: handleCaptchaCancelled, onReset: handleCaptchaReset }));
    }
    const selectedLocationIds = new Set(query.locationIds);
    // Determine the position of care teams above and below alt providers based on feature flags
    const isReversed = (0, utils_directBook_1.shouldShowCareTeamsBelowAltProviders)(featureFlags);
    const providerSections = [
        showCareTeamsOnStep2 && !aboveMd && (react_2.default.createElement(Sidebar_1.CareTeamsProviders, { key: "care-teams", config: config, careTeamsProviders: careTeamsProviders, services: services, track: track })),
        showAltProvidersForMobile && (react_2.default.createElement(MobileAltProviders_1.default, { key: "alt-providers", service: service, config: config, track: track }))
    ].filter(Boolean);
    return (react_2.default.createElement(styles_1.Container, { "data-testid": "ApptTime" },
        (0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags) && !useNewFilters ? (react_2.default.createElement(CollapsibleFilters_1.CollapsibleFilters, { id: "appt-time-filters", config: config, onCollapse: onScroll, offsetTop: offsetTop, initialState: {
                filterCount,
                selectedLocationIds,
                highlightedLocId,
                locationId,
                visit_method: query.purpose.visit_method,
                locsByAvailability,
                mapUrl: mapApiKey && (0, utils_1.buildMapUrl)(mapApiKey),
                date: jumpedToDate,
                dayOfWeek: Array.from(filterBy.dayOfWeek),
                timeOfDay: Array.from(filterBy.timeOfDay)[0]
            }, onSelectedLocationChange: () => {
                send(Actions_1.RESET_LOCATION_FILTER);
                track(Tracking_1.userEvents.APPT_CHANGE_LOC);
            }, onDayOfWeekChange: () => {
                track(Tracking_1.userEvents.APPT_CHANGE_DAY);
            }, onTimeOfDayChange: () => {
                track(Tracking_1.userEvents.APPT_CHANGE_TIME);
            }, onDateChange: () => {
                track(Tracking_1.userEvents.APPT_JUMP_TO_DATE, {
                    patient_rel: query.patientRel,
                    purpose: query.purpose.name,
                    loaded_appointments_count: appointments.length
                });
            }, onClearFilters: () => send(Actions_1.CLEAR_ALL_FILTERS), onApplyFilters: (state) => {
                send([
                    {
                        type: Actions_1.SET_ALL_FILTERS,
                        data: {
                            locationIds: Array.from(state.selectedLocationIds),
                            currentId: state.locationId,
                            dayOfWeek: new Set(state.dayOfWeek),
                            timeOfDay: new Set(state.timeOfDay === TimeFilter_1.TIME_OF_DAY.ALL ? [] : [state.timeOfDay]),
                            periodStart: state.date
                        }
                    }
                ]);
            } })) : ((!useNewFilters || aboveMd) && (react_2.default.createElement(styles_1.MapContainer, { "data-testid": "Map" }, (0, utils_1.hasAnyVideoPhoneAppt)(query.purpose.visit_method) ? (react_2.default.createElement(styles_1.ApptTimeLeftContainer, { headerHeight: headerHeight },
            react_2.default.createElement(VisitTypeContent_1.default, { type: query.purpose.visit_method }))) : (react_2.default.createElement(styles_1.MapContent, { headerHeight: headerHeight },
            react_2.default.createElement(ProviderLocations_1.default, { selectedLocationIds: selectedLocationIds, highlightedLocId: highlightedLocId, url: mapApiKey && (0, utils_1.buildMapUrl)(mapApiKey), bookableLocations: locsByAvailability.bookable, nonBookableLocations: locsByAvailability.nonBookable, onSelect: (ids, currentId) => {
                    track(Tracking_1.userEvents.APPT_CHANGE_LOC);
                    send(Actions_1.RESET_LOCATION_FILTER);
                    send({
                        type: Actions_1.UPDATE_APPT_QUERY,
                        data: { locationIds: Array.from(ids), currentId }
                    });
                }, locationId: locationId, mapEventsToRegister: {
                    bounds_changed: (mapRef) => {
                        // set current map zoom value
                        getMapZoomRefOnLoad.current = mapRef.current.zoom;
                    },
                    zoom_changed: (mapRef) => {
                        const zoom = mapRef.current.zoom;
                        const value = getMapZoomRefOnLoad.current;
                        value &&
                            zoom &&
                            (value > zoom
                                ? track('user_action.direct_book.appt_time.map_zoom_out')
                                : track('user_action.direct_book.appt_time.map_zoom_in'));
                    }
                }, config: config, awsMapConfig: awsMapConfig })))))),
        react_2.default.createElement(ApptList_1.default, { useNewFilters: useNewFilters, apptDensity: apptDensity, provider: provider, config: config, query: query, currentState: state, appointments: appointments, bookableLocations: locsByAvailability.bookable, nonBookableLocations: locsByAvailability.nonBookable, selectedLocationIds: selectedLocationIds, locationId: locationId, onSelect: (ids, currentId) => {
                track(Tracking_1.userEvents.APPT_CHANGE_LOC);
                send(Actions_1.RESET_LOCATION_FILTER);
                send({
                    type: Actions_1.UPDATE_APPT_QUERY,
                    data: { locationIds: Array.from(ids), currentId }
                });
            }, onHighlightLocId: (id) => setHighLightedLocId(id), onClearFilters: () => send((0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags)
                ? Actions_1.CLEAR_ALL_FILTERS
                : Actions_1.CLEAR_FILTERS), onDayOfWeekChange: (dayOfWeek) => {
                track(Tracking_1.userEvents.APPT_CHANGE_DAY);
                send({
                    type: Actions_1.SET_LOCAL_FILTER,
                    data: { dayOfWeek }
                });
            }, onTimeOfDayChange: (timeOfDay) => {
                track(Tracking_1.userEvents.APPT_CHANGE_TIME);
                send({
                    type: Actions_1.SET_LOCAL_FILTER,
                    data: { timeOfDay }
                });
            }, onLoadMore: () => {
                track(Tracking_1.userEvents.APPT_LOAD_MORE, {
                    patient_rel: query.patientRel,
                    purpose: query.purpose.name,
                    loaded_appointments_count: appointments.length
                });
                send({
                    type: Actions_1.LOAD_MORE,
                    data: { periodStart: nextPeriodStart(appointments) }
                });
            }, onSelectAppt: (appointment) => send({
                type: Actions_1.SELECT_APPOINTMENT,
                data: { appointment }
            }), onDateChange: (date) => {
                track(Tracking_1.userEvents.APPT_JUMP_TO_DATE, {
                    patient_rel: query.patientRel,
                    purpose: query.purpose.name,
                    loaded_appointments_count: appointments.length
                });
                send({
                    type: Actions_1.JUMP_TO_DATE,
                    data: { periodStart: date.format('YYYY-MM-DD') }
                });
            }, track: track }),
        isReversed ? providerSections.reverse() : providerSections));
}
exports.default = ApptTime;
ApptTime.propTypes = propTypes;
ApptTime.defaultProps = defaultProps;
//# sourceMappingURL=ApptTime.js.map